import { render, staticRenderFns } from "./IncomeSales.vue?vue&type=template&id=61bb53db"
import script from "./IncomeSales.vue?vue&type=script&lang=js"
export * from "./IncomeSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports